// extracted by mini-css-extract-plugin
module.exports = {"conjurePage":"ios-newsletter_conjurePage__lub8J","conjureContent":"ios-newsletter_conjureContent__sw3jZ","privacyFooter":"ios-newsletter_privacyFooter__pXzmY"};